// extracted by mini-css-extract-plugin
module.exports = {"grey":"layout_grey__31Aue","bodyClass":"layout_bodyClass__27Wth"};